// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__tDldA","title":"Advt_title__SAyFC","qrBlock":"Advt_qrBlock__8PauK","qrItem":"Advt_qrItem__tAgE6","qr":"Advt_qr__p75lz"};